var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{wrapper_absolute: _vm.absolute}},[_c('div',{staticClass:"loader",style:({width: _vm.size, height: _vm.size, 'border-width': _vm.border})})])
}
var staticRenderFns = []

export { render, staticRenderFns }